export default __webpack_public_path__ + "static/media/aiFaceActive.svg.d120d454.svg";